module.exports = __webpack_public_path__ + "img/PLN.0ef5bc79.svg";